<template>
  <v-app style="background: rgb(238, 238, 238,0.5);">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;width:95%;padding-left:0.4rem;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">
          创建报障工单
          <!-- <span v-if="companyInfo.COMPANY_NAME"> - {{companyInfo.COMPANY_NAME}}</span> -->
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container>
        <v-form ref="form" style="margin-right:0.3rem;margin-top:0.35rem;margin-bottom:0.8rem;">

          <v-list-item>
            <v-list-item-icon style="width: 60px;margin-right:0px;">
              <span style="color:#808080;font-size:16px">团队:</span>
            </v-list-item-icon>
            <v-list-item-content>
              <div>
                <select id="us-select" style="color:#ccc;width:100%;outline:none;" v-if="loading"  >
                  <option value="" >正在加载...</option>
                </select>
                <select id="us-select" style="color:#808080;width:100%;outline:none;" v-model="selectVal" v-else >
                  <option :value="item.value" v-for="(item,index) in companyList" :key="index">{{item.label}}</option>
                </select>
                <i class="fa fa-angle-down" aria-hidden="true" style="font-size:1.2rem;color:#808080;position:absolute;right:1.2rem;pointer-events:none;" ></i>
              </div>
            </v-list-item-content>
          </v-list-item>

          <v-row style="margin-left:1.2rem;">
            <v-col cols="12" sm="6" md="4" style="padding:0;padding-left:0.8rem;">
                <v-chip-group mandatory active-class="primary--text">
                  <v-chip class="primary--text" :class="{'priority0-sled':form.gz_priority===0}" color="#E3F2FD" style="border-radius:5px;padding:0 1rem;" @click="selectPriority(0)">
                    <span>一般</span>
                  </v-chip>
                  <v-chip class="warning--text" :class="{'priority2-sled':form.gz_priority===2}" color="rgba(255,236,179,0.45)" style="border-radius:5px;padding:0 1rem;" @click="selectPriority(2)">
                    <span>紧急</span>
                  </v-chip>
                </v-chip-group>
            </v-col>
          </v-row>

          <v-text-field v-model="form.gz_title" label="故障标题" prepend-icon="fa fa-hashtag" placeholder=""></v-text-field>
          <v-textarea  v-model="form.gz_content" auto-grow label="故障内容" rows="1" prepend-icon="fa fa-align-left" placeholder=""></v-textarea>
          <div>
              <v-icon>mdi-camera</v-icon>
              <span style="margin-left:0.68rem;color: rgba(0, 0, 0, 0.6);"></span>
          </div>
          <TUploadPicture ref="uploadPicture" />
          <!-- <PrioritySelect style="margin-top:0.5rem;" :value.sync="form.gz_priority" /> -->
        </v-form>
        <v-divider></v-divider>
        <div>
            <v-card-text style="font-size:0.75rem;">
                <div>提示: 您好！您提交的工单，我们会为你尽快解决！！</div>
            </v-card-text>
            <div no-gutters style="padding-bottom:5rem;margin-top:1rem;text-align:center;">
              <v-btn large color="primary" style="width:80%;" :loading="submitLoading" :disabled="submitLoading" @click="submitOrder">提交</v-btn>
            </div>
        </div>
      </v-container>
    </v-content>
  </v-app>


</template>

<script>
import TUploadPicture from '../../components/TUploadPictureV2'
// import PrioritySelect from '../../components/PrioritySelect'
export default {
  components: { TUploadPicture },
  props: {
  },
  data() {
    return {
      form: {
        gz_title: '',
        gz_content: '',
        gz_date_time: '',
        gz_priority: 0,
        gz_remark: '',
        pictures: []
      },
      timeSelectVis: false,
      companyInfo: {},
      loading: true,
      selectVal: '',
      companyList: [],
      submitLoading: false
    };
  },
  methods: {
    init() {
      var that = this
      that.form = {
        gz_title: '',
        gz_content: '',
        gz_date_time: '',
        gz_priority: 0,
        gz_remark: '',
        pictures: []
      };
      if (that.$route.query.title) {
        that.form.gz_title = that.$route.query.title
      }
      if (that.$route.query.content) {
        that.form.gz_content = that.$route.query.content
      }
      that.$refs.uploadPicture.init()
      that.selectVal = that.companyInfo.COMPANY_CODE
      that.getCompanyList()
    },
    submitOrder() {
      var that = this
      if (that.form.gz_title === '') {
        that.$toast.warning('请填写故障标题');
        return
      }
      var pictures = that.$refs.uploadPicture.getPictureList()
      for (let index = 0; index < pictures.length; index++) {
        var item = pictures[index];
        that.form.pictures.push(item.GZ_PICTURE_ID)
      }
      // console.log('form', that.form);
      // var staffInfo = that.$AppHelper.getCustomData('staff_info');
      // var company_code = staffInfo.COMPANY_CODE;
      var company_code = that.selectVal;
      that.submitLoading = true
      that.$api.bz.createGzOrder({ str_order: JSON.stringify(that.form), company_code: company_code }).then(res => {
        that.submitLoading = false
        if (!res.success) {
          that.$toast.warning('新增失败');
          console.log('新增报障工单失败', res);
          return
        }
        that.init()
        that.$router.goActionResPage({ tag: 1, text: '新增成功', auto_ret: 'y', dest: -2 })
      });
    },
    selectPriority(val) {
      this.form.gz_priority = val
    },
    goBack() {
      this.$router.goBack()
    },
    async getCompanyList() {
      var that = this
      await that.$api.bz.getCompanyList().then(res => {
        that.loading = false
        // console.log('获取团队列表', res);
        if (!res.success) {
          console.log('获取团队列表失败', res);
          return;
        }
        var data = res.data
        if (data.length === 0) {
          return
        }
        that.companyList = []
        for (let index = 0; index < data.length; index++) {
          var item = data[index];
          that.companyList.push({ label: item.COMPANY_NAME, value: item.COMPANY_CODE })
        }
      })
    }
  },
  mounted() {
    var that = this
    that.companyInfo = that.$AppHelper.getCustomData('company_info');
    that.init()
  },
  created() {}
};
</script>

<style scoped>
.priority0-sled{
 background-color: #1976d2 !important;
 color: #fff !important;
}
.priority2-sled{
 background-color: #fb8c00 !important;
 color: #fff !important;
}
</style>
